export const ENABLE_DIARY_COVER_CUSTOMIZATION = true;
